/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../Layouts/Layout";
import { Helmet } from "react-helmet-async";
import AboutUsSection from "./AboutUsSection";
import TeamSection from "../../../../components/Sections/Generic/TeamSection/TeamSection";
import ContainerFullWidth from "../../../../components/Container/ContainerFullWidth";
import { gaSet } from "../../../../services/cookieService";
import GreyBackgroundWrapper from "../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import HeadlineSection from "../../../../components/Sections/Generic/HeadlineSection/HeadlineSection";
import TrustSection from "../../../../components/Sections/Generic/TrustSection/TrustSection";
import PartnersSection from "../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import ServiceworldStepSection from "../../../../components/Sections/Generic/ServiceworldStepSection/ServiceworldStepSection";
import AreaSelection from "../../../../components/AreaSelection/AreaSelection";

const AboutUsPage = () => {
  const title = "Über uns | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"Wir finden die beste Lösung für Ihr Problem!"} typographyVariant={"h1"} />
      <GreyBackgroundWrapper>
        <ContainerFullWidth>
          <AboutUsSection />
          <TeamSection />
        </ContainerFullWidth>
      </GreyBackgroundWrapper>
      <HeadlineSection headline={"Bei diesen Themen helfen wir gerne weiter"} typographyVariant={"h2"} />
      <AreaSelection />
      <TrustSection />
      <PartnersSection />
      <GreyBackgroundWrapper>
        <ContainerFullWidth>
          <ServiceworldStepSection />
        </ContainerFullWidth>
      </GreyBackgroundWrapper>
    </Layout>
  );
};

export default AboutUsPage;
